/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SummarizeRequestBody,
  SummarizeRequestBody$Outbound,
  SummarizeRequestBody$outboundSchema,
} from "../components/summarizerequestbody.js";

export type SummarizeChatSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SummarizeChatRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  summarizeRequestBody: SummarizeRequestBody;
};

/** @internal */
export type SummarizeChatSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SummarizeChatSecurity$outboundSchema: z.ZodMiniType<
  SummarizeChatSecurity$Outbound,
  SummarizeChatSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function summarizeChatSecurityToJSON(
  summarizeChatSecurity: SummarizeChatSecurity,
): string {
  return JSON.stringify(
    SummarizeChatSecurity$outboundSchema.parse(summarizeChatSecurity),
  );
}

/** @internal */
export type SummarizeChatRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SummarizeRequestBody: SummarizeRequestBody$Outbound;
};

/** @internal */
export const SummarizeChatRequest$outboundSchema: z.ZodMiniType<
  SummarizeChatRequest$Outbound,
  SummarizeChatRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    summarizeRequestBody: SummarizeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      summarizeRequestBody: "SummarizeRequestBody",
    });
  }),
);

export function summarizeChatRequestToJSON(
  summarizeChatRequest: SummarizeChatRequest,
): string {
  return JSON.stringify(
    SummarizeChatRequest$outboundSchema.parse(summarizeChatRequest),
  );
}
